export default "__VITE_ASSET__b236257e__"